import contactInfo_en from './contact-info_en.json'
import overviewWidget_en from './overview-widget_en.json'

const lcr_us_resources = {
  en: {
    ...contactInfo_en,
    ...overviewWidget_en,
  },
}

export default lcr_us_resources
